let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1cRAv")).then(() => parcelRequire('3JjhD'));